// NOTE: this is for Borongan Smart City only

// TODO: Refactor later, remove unecessary codes and separate blocks into components
/* eslint-disable */
import React, { useContext, useState, useEffect } from 'react';
import { withRouter } from 'react-router-dom';
import _ from 'lodash';
import { connect } from 'react-redux';
import withForm from 'modules/common/hoc/withForm';
import Modal from 'modules/common/components/Modal';
import { get, getJson } from 'session';
import { Acl } from 'modules/common/components/Acl';
import CmsContext from 'context/CmsContext';
import { reactSelectCustomStyleCms } from 'helper';
import moment from 'moment';
import DateInputPicker from 'modules/common/components/DateInputPicker2';
import PropTypes from 'prop-types';
import { ModalContext } from 'App';
import useFormValidator from 'useFormValidator';
import NumberFormat from 'react-number-format';
import * as actions from '../actions';
import * as c from '../constant';

import { InputTemplate } from "../../../common/components/inputComponents";
import AddressGroupComponent from "../../../common/address/AddressGroupComponent";

const AddRecordModalBoronganV2 = ({
  permissions,
  createRecordManualImportBorongan,
  getListManualImportBorongan,
  history,
  creating,
  type,
  updateRecordManualImportBorongan,
  updateAmountFeesBorongan,
  dataInfo,
  dataInclude,
  calculatePenaltyDiscount,
  calculating,
  id,
}) => {
  const cmsContext = useContext(CmsContext);
  const CMS_COMPONENTS = cmsContext.findByType('COMPONENTS');
  // const CMS_MASKINGS = cmsContext.findByType('MASKINGS');

    const [formData, setFormData] = useState({
    ..._.omit(c.INITIAL_FORMDATA_BORONGAN, ['values']),
    location_region: _.get(CMS_COMPONENTS, "SMART_CITY_SET_SPECIFIC_REGION_FOR_ADDRESS_BILLING") || "",
    location_province: _.get(CMS_COMPONENTS, "SMART_CITY_SET_SPECIFIC_PROVINCE_FOR_ADDRESS_BILLING") || "",
    location_municipality: _.get(CMS_COMPONENTS, "SMART_CITY_SET_SPECIFIC_MUNICIPALITY_FOR_ADDRESS_BILLING") || "",
  });

  // co-owners field
  const [coOwnersData, setCoOwnersData] = useState(c.CO_OWNER_FORMDATA);

  const [tab, setTab] = useState(0)
  const setModal = useContext(ModalContext);
  const [pinFormat, setPinFormat] = useState(false);
  const isStatusPaid = _.get(dataInfo, "payment_status")?.toUpperCase()?.includes("PAID") || false

  const isACLAssessor = Acl(permissions, ['VIEW RPTAX ADD RECORDS ASSESSOR'])

  let commonValidation = {
    tdn: 'required',
    pin: 'required',
    account_name: 'required',
    period_covered_from: 'required',
    year: 'required',
    owner_name: 'required',

    location_region: 'required',
    location_province: 'required',
    location_municipality: 'required',
    location_barangay: 'required',
    location_zone: 'required',
    location_street: 'required',
    kind_of_property: 'required',
    classification: 'required',
  };

    const validateForm = useFormValidator(formData, commonValidation);
    const validateCoOwnersForm = useFormValidator(coOwnersData, {
      name: 'required',
    });

  const onChange = e => {
    return setFormData({
      ...formData,
      [e.target.name]:
        e.target.type === 'checkbox' ? e.target.checked : e.target.value,
    });
  };

  const onChangeBusinessAddress = (e) => {
    setFormData(prevForm => ({
      ...prevForm,
      location_region: _.get(e, "target.value.region_code"),
      location_province: _.get(e, "target.value.province_code"),
      location_municipality: _.get(e, "target.value.municipality_code"),
      location_barangay: _.get(e, "target.value.barangay_code"),
      location_street: _.get(e, "target.value.street"),
      location_zone: _.get(e, "target.value.zip_code"),
    }));
  };

  useEffect(() => {
    validateForm.validate();
  }, [Object.values(formData).join(',')]);

  useEffect(() => {
    validateCoOwnersForm.validate();
  }, [Object.values(coOwnersData).join(',')]);

  const handlePinFormat = e => {
    if (e.target.checked) {
      setPinFormat(true);
    } else {
      setPinFormat(false);
    }
  };

  const handleOnChangeDate = key => ({ target: { value } }) => {
    setFormData({
      ...formData,
      [key]: value,
    });
  };

  const handleOnSubmit = e => {
    e.preventDefault();

    const args = {
      ...formData,
      period_covered_from: `${moment(_.get(formData, 'period_covered_from')).format(
        'YYYY-MM-DD'
      )}`,
    };

    if (!validateForm.response.is_passed) {
      if(tab === 0) {
          setTab(+tab+1)
      }
      if(tab === 1) {
          setTab(+tab+1)
      }
      // if(tab === ) {
      //     setTab(+tab+1)
      // }
      return false;
    }

    // temporarys add condition to only submit if in page 3 while other pages doesn't have data yet
    if (validateForm.response.is_passed) {
      if (tab === 0 && tab !== 2) {
          setTab(+tab+1)
      }

      if (!isACLAssessor) {
        if (tab === 1 && tab !== 2) {
          setTab(+tab+1)
        }
      }

      if (tab === (!isACLAssessor ? 2 : 1)) {
        // submit
        if (type === 'ADD') {
          createRecordManualImportBorongan(args, () => {
            setModal({ isOpen: false });
            getListManualImportBorongan({
              // overwrite_previous: 0,
              // is_active: 1,
            });
            history.push(`/billing/rptax`);
          });
        }
    
        if (type === 'EDIT') {
          const updateFeesArgs = {
            assessed_value: _.get(formData, "assessed_value"),
            tax_due: _.get(formData, "tax_due"),
            discount: _.get(formData, "discount"),
            penalty: _.get(formData, "penalty"),
          }
          updateAmountFeesBorongan(id, updateFeesArgs, () => {
            setModal({ isOpen: false });
          });
          updateRecordManualImportBorongan(id, args, () => {
            setModal({ isOpen: false });
            getListManualImportBorongan({
              overwrite_previous: 0,
              is_active: 1,
            });
            history.push(`/billing/rptax`);
          });
        }
      }
      return false;
    }

    return true
  };

  const closeModal = e => {
    e.preventDefault();
    setModal({ isOpen: false });
  };

  const handleOnChangeSelect = key => e => {
    setFormData({
      ...formData,
      [key]: e ? e.value : '',
    });
    if (key === 'year') {
      setFormData({
        ...formData,
        [key]: e ? e.value : '',
        mode_of_payment_1: `${e.value}-1`,
        mode_of_payment_2: `${e.value}-4`,
      });
    }
  };
  
  const onUpdateCoOwners = (id) => e => {
    e.preventDefault()

    const updatedCoOwnerData = {
      name: e.target.value.toUpperCase(),
    }

    // for validation
    setCoOwnersData({
      ...coOwnersData,
      ...updatedCoOwnerData,
    });

    setFormData({
      ...formData,
      // activities: [formData.activities[itemId] ? formUpdate : formData.activities]
      co_owners: [
        ...formData.co_owners.map((item, index) =>
          index === id ? updatedCoOwnerData : item
        ),
      ],
    });
  };

  const handleAddCoOwnersField = e => {
  e.preventDefault()

  setFormData({
    ...formData,
    // co_owners: [..._.get(formData, "co_owners"), coOwnersData],
    co_owners: [..._.get(formData, "co_owners"), {}],
  });

  setCoOwnersData({
    name: "",
  });

  // setFocus(false)
};

const handleDeleteCoOwnerField = (id) => {
  const arr = _.filter(
    _.get(formData, "co_owners"),
    (_item, index) => index !== id
  );

  setFormData({
    ...formData,
    co_owners: [...arr],
  });
};

  useEffect(() => {
    if (type === 'EDIT') {
      const splitStr = dataInfo.pin.replace(/\s+/g, '-').length;
      if (splitStr > 19) {
        setPinFormat(true);
      } else {
        setPinFormat(false);
      }

      setFormData({
        tdn: dataInfo.tdn,
        pin: dataInfo.pin,
        account_number: dataInfo.account_number,
        account_name: dataInfo.account_name,
        period_covered_from: !_.get(dataInfo, 'period_covered_from', "") ? "" : moment(_.get(dataInfo, 'period_covered_from', ""))?.format('MM-DD-YYYY'),
        year: dataInfo?.year,
        owner_name: dataInfo.owner_name,
        location_region: dataInfo.location_region,
        location_province: dataInfo.location_province,
        location_municipality: dataInfo.location_municipality,
        location_barangay: dataInfo.location_barangay,
        location_district: dataInfo.location_district,
        location_zone: dataInfo.location_zone,
        location_street: dataInfo.location_street,
        area: dataInfo.area,
        oct_tct_cloa_no: dataInfo.oct_tct_cloa_no,
        survey_no: dataInfo.survey_no,
        lot_no: dataInfo.lot_no,
        block_no: dataInfo.block_no,
        kind_of_property: dataInfo.kind_of_property,
        classification: dataInfo.classification,
        special_class: dataInfo.special_class,
        boundaries_north: dataInfo.boundaries_north,
        boundaries_south: dataInfo.boundaries_south,
        boundaries_east: dataInfo.boundaries_east,
        boundaries_west: dataInfo.boundaries_west,
        first_quarter: dataInfo.first_quarter,
        second_quarter: dataInfo.second_quarter,
        third_quarter: dataInfo.third_quarter,
        fourth_quarter: dataInfo.fourth_quarter,
        co_owners: dataInclude?.coOwners.map(item => ({ name: item.attributes.name})) || [],

        assessed_value: dataInfo.assessed_value,
        tax_due: dataInfo.tax_due,
        penalty: dataInfo.penalty,
        discount: dataInfo.discount,
      }); 
    }
  }, [dataInfo, dataInclude]);

  const MAX_VAL = 9999999999999999.99;
  const withValueCap = inputObj => {
    const { value } = inputObj;
    if (value <= MAX_VAL) return true;
    return false;
  };


// stepper:
const paginateButton = () => {
  return (
    <div className="py-1"> 
      {tab !== (!isACLAssessor ? 2 : 1) && (
        <div className="col-12 d-flex justify-content-center mt-3">
          {tab !== 0 && (
            <button
              type="button"
              onClick={() => setTab(+tab - 1 < 0 ? 0 : +tab - 1)}
              className="btn btn-light button-cancel-2 mr-1"
              // temporary style
              style={{ backgroundColor: '#323943', color: '#fff' }}
            >
              Previous
            </button>
          )}
          {tab === 0 && (
            <button
              type="button"
              onClick={closeModal}
              className="btn btn-light button-cancel-2 mr-1"
              // temporary style
              style={{ backgroundColor: '#323943', color: '#fff' }}
            >
              Cancel
            </button>
          )}
          <button
            type="submit"
            className="btn btn-light button-proceed ml-1 cms-bg-color-primary text-light"
            // disabled={
            //   (tab === 0 && !validateForm.response.is_passed) ||
            //   (tab === 1 && !validateForm.response.is_passed) ||
            //   (tab === 2 && !validateForm.response.is_passed)
            // }
          >
            {/* <i className="fas fa-spinner fa-spin fa-lg" /> */}
            Next
          </button>
        </div>
      )}
      {tab === (!isACLAssessor ? 2 : 1) && (
        <div className="col-12 d-flex justify-content-center mt-3">
          <button
            type="button"
            onClick={() => setTab(+tab - 1 < 0 ? 0 : +tab - 1)}
            className="btn btn-link button-cancel-2 mr-1"
            style={{ backgroundColor: '#323943', color: '#fff' }}
          >
            Previous
          </button>
          <button
            disabled={(tab === (!isACLAssessor ? 2 : 1) && !validateForm.response.is_passed )}
            type="submit"
            className={`btn btn-light button-proceed ml-1 cms-bg-color-primary ${isStatusPaid && "d-none"}`}
            style={{ color: '#fff' }}
          >
            {creating ? <i className="fas fa-spinner fa-spin fa-lg" /> : `Save`}
          </button>
        </div>
      )}
    </div>
  );
};

  const handleCalculatePenaltyAndDiscount = () => {
    const penaltyAndDiscountArgs = {
      tdn: _.get(formData, "tdn"),
      pin: _.get(formData, "pin"),
      year: _.get(formData, "year"),
      tax_due: _.get(formData, "tax_due"),
    }
    calculatePenaltyDiscount(penaltyAndDiscountArgs, res => {
      const data = _.get(res, "res.data")
      setFormData({
        ...formData, 
        first_quarter: _.get(data, "quarterly_payments.first_quarter"),
        second_quarter: _.get(data, "quarterly_payments.second_quarter"),
        third_quarter: _.get(data, "quarterly_payments.third_quarter"),
        fourth_quarter: _.get(data, "quarterly_payments.fourth_quarter"),

        penalty: _.get(data, "full_payment.penalty_total"),
        discount: _.get(data, "full_payment.discount"),
      })
    })
  }

  return (
    <Modal.Body className="p-2">
      <form onSubmit={handleOnSubmit}>
        <div className="px-2">
          {/* 
            1st Page
            note: Move each page to a separate component
          */}
          {
            tab === 0 && (
              <>
                <div className="full-group-v2">
                  <div className="form-row">
                    <InputTemplate
                      // isInputMask
                      title="Tax Declaration Number (TDN)"
                      htmlFor="tdn"
                      containerClassName="col-sm-12 col-md-6 col-lg-4"
                      formValidatorMsg={validateForm.renderMessage("tdn")}
                      // Input component props
                      placeholder=""
                      // className="full-input-v2 text-uppercase"
                      className="full-input-v2"
                      disabled={isStatusPaid || (type === "EDIT" && !isACLAssessor)}
                      id="tdn"
                      name="tdn"
                      type="text"
                      autoComplete="none"
                      onChange={onChange}
                      value={_.get(formData, 'tdn')?.toUpperCase() || ''}
                    />
                    <InputTemplate
                      // isInputMask
                      title="Property Identification Number (PIN)"
                      htmlFor="pin"
                      containerClassName="col-sm-12 col-md-6 col-lg-4"
                      formValidatorMsg={validateForm.renderMessage("pin")}
                      // Input component props
                      placeholder=""
                      // className="full-input-v2 text-uppercase"
                      className="full-input-v2"
                      disabled={isStatusPaid || (type === "EDIT" && !isACLAssessor)}
                      id="pin"
                      name="pin"
                      type="text"
                      autoComplete="none"
                      onChange={onChange}
                      value={_.get(formData, 'pin')?.toUpperCase() || ''}
                    />
                    <InputTemplate
                      title="Account Number / Owner ID"
                      htmlFor="account_number"
                      containerClassName="col-sm-12 col-md-6 col-lg-4"
                      // formValidatorMsg={validateForm.renderMessage("account_number")}
                      // Input component props
                      placeholder=""
                      // className="full-input-v2 text-uppercase"
                      className="full-input-v2"
                      disabled={isStatusPaid || (type === "EDIT" && !isACLAssessor)}
                      id="account_number"
                      name="account_number"
                      type="text"
                      autoComplete="none"
                      onChange={onChange}
                      value={_.get(formData, 'account_number')?.toUpperCase() || ''}
                    />
                    <InputTemplate
                      // title="Account Name"
                      title="Company / Corporation / Building Name"
                      htmlFor="account_name"
                      containerClassName="col-sm-12 col-md-6 col-lg-4"
                      formValidatorMsg={validateForm.renderMessage("account_name")}
                      // Input component props
                      placeholder="Company / Corporation / Building Name"
                      // className="full-input-v2 text-uppercase"
                      className="full-input-v2"
                      disabled={isStatusPaid || (type === "EDIT" && !isACLAssessor)}
                      id="account_name"
                      name="account_name"
                      type="text"
                      autoComplete="none"
                      onChange={onChange}
                      value={_.get(formData, 'account_name')?.toUpperCase() || ''}
                    />
                    <InputTemplate
                      // title="Billing Date"
                      title="Period Covered From"
                      htmlFor="period_covered_from"
                      containerClassName="col-sm-12 col-md-6 col-lg-4"
                      formValidatorMsg={validateForm.renderMessage("period_covered_from")}
                      withCustomInputComponent={() => (
                        <DateInputPicker
                          disabled={isStatusPaid || (type === "EDIT" && !isACLAssessor)}
                          inputClassName="full-input form-input-record-v2"
                          btnClassName="button-date2-v2 cms-bg-color-secondary cms-outline-secondary"
                          onChange={handleOnChangeDate('period_covered_from')}
                          placeholder="MM/DD/YYYY"
                          value={_.get(formData, 'period_covered_from') || ''}
                        />
                      )}
                    />
                    <InputTemplate
                      title="Year"
                      htmlFor="year"
                      containerClassName="col-sm-12 col-md-6 col-lg-4"
                      formValidatorMsg={validateForm.renderMessage("year")}
                      withCustomInputComponent={() => (
                        <DateInputPicker
                          showYearPicker
                          disabled={isStatusPaid || (type === "EDIT" && !isACLAssessor)}
                          inputClassName="full-input form-input-record-v2"
                          placeholder="YYYY"
                          btnClassName="button-date2-v2 cms-bg-color-secondary cms-outline-secondary"
                          onChange={handleOnChangeDate('year')}
                          value={_.get(formData, 'year')?.toString() || ""}
                        />
                      )}
                    />
                  </div>
                </div>

                <div className="full-group-v2">
                 <h3 className="font-weight-bolder mb-2 mt-4 cms-text-primary">Owners</h3>
                  <div className="form-row">
                    <InputTemplate
                      title="Owner's Full Name"
                      htmlFor="owner_name"
                      containerClassName="col-sm-12 col-md-6 col-lg-4"
                      formValidatorMsg={validateForm.renderMessage("owner_name")}
                      // Input component props
                      placeholder="Full Name"
                      // className="full-input-v2 text-uppercase"
                      className="full-input-v2"
                      disabled={isStatusPaid || (type === "EDIT" && !isACLAssessor)}
                      id="owner_name"
                      name="owner_name"
                      type="text"
                      autoComplete="none"
                      onChange={onChange}
                      value={_.get(formData, 'owner_name')?.toUpperCase() || ''}
                    />
                    {/* add co-owner lists here */}
                    {_.get(formData, 'co_owners')?.map((item, i) => {
                      return (
                        <InputTemplate
                          key={i}
                          title="Co-owners's Full Name"
                          // htmlFor={`${item}-${i}`}
                          htmlFor="name"
                          containerClassName="col-sm-12 col-md-6 col-lg-4"
                          // formValidatorMsg={_.isEmpty(_.get(item, 'name')) ? validateCoOwnersForm.renderMessage("name") : (<small className="fa fa-check text-success" style={{ fontSize: 10, padding: '1px' }}/>)}
                          formValidatorMsg={(type === "EDIT" && isStatusPaid) ? false : validateCoOwnersForm.renderMessage("name")}
                          // Input component props
                          placeholder="_"
                          // className="full-input-2 text-uppercase"
                          className="full-input-2"
                          disabled={isStatusPaid || (type === "EDIT" && !isACLAssessor)}
                          type="text"
                          name="name"
                          id="name"
                          // onChange={onChangeCoOwners}
                          onChange={onUpdateCoOwners(i)}
                          value={_.get(item, "name")?.toUpperCase() || ""}
                          // action button (undo)
                          actionButtonContainerClass="border"
                          withActionButton={() => {
                            return (
                              <button
                                type="button"
                                disabled={isStatusPaid || (type === "EDIT" && !isACLAssessor)}
                                className="btn no-btn px-2 border-none"
                                onClick={() => handleDeleteCoOwnerField(i)}
                              >
                                <i className="fas fa-trash-alt text-danger" style={{backgroundColor: 'none'}}></i>
                              </button>
                            )
                          }}
                        />
                      )
                    })}                    
                    <div className="form-input-group-v2 my-1 col-sm-12 col-md-6 col-lg-4 d-flex align-items-end">
                      <button
                        type="button"
                        disabled={isStatusPaid || (type === "EDIT" && !isACLAssessor)}
                        onClick={handleAddCoOwnersField}
                        style={{ height: '43px' }}
                        className="btn btn-primary cms-bg-color-secondary cms-outline-secondary mr-2">
                        <i className="fa fa-plus mr-3" /> Add Co-Owner
                      </button>
                    </div>
                  </div>
                </div>
                <div className="full-group-v2">
                 <h3 className="font-weight-bolder mb-2 mt-4 cms-text-primary">Location</h3>
                  <div className="form-row">                    
                    <AddressGroupComponent
                      name=""
                      // isDisabled="region_code, province_code"
                      isDisabled={`region_code, province_code, municipality_code, ${type === "EDIT" && !isACLAssessor && "barangay_code, street, zip_code"}` || isStatusPaid}
                      region_name="location_region"
                      province_name="location_province"
                      municipality_name="location_municipality"
                      // district_name="location_district"
                      // zone_name="location_zone"
                      barangay_name="location_barangay"
                      street_name="location_street"
                      zip_code_name="location_zone"
                      onChange={onChangeBusinessAddress}
                      value={{
                        region_code: _.get(formData, "location_region") || "",
                        // region_code: "080000000" || "",
                        province_code: _.get(formData, "location_province") || "" ,
                        municipality_code: _.get(formData, "location_municipality") || "" ,
                        barangay_code: _.get(formData, "location_barangay") || "",
                        street: _.get(formData, "location_street") || "",
                        zip_code: _.get(formData, "location_zone") || "",
                      }}
                      validatorMessage={validateForm.renderMessage}
                    />
                  </div>
                </div>
              </>
            )
          }
          {/* 2nd Page */}
          {
            tab === 1 && (
              <>
                <div className="full-group-v2">
                  <div className="form-row">
                    <InputTemplate
                      title="Area (in sqm)"
                      htmlFor="area"
                      containerClassName="col-sm-12 col-md-6"
                      // formValidatorMsg={validateForm.renderMessage("area")}
                      withCustomInputComponent={() => (
                        <NumberFormat
                          name="area"
                          id="area"
                          placeholder="0"
                          // className="full-input-v2 text-uppercase my-2"
                          className="full-input-v2"
                          onValueChange={values => {
                            const { floatValue } = values
                            setFormData(() => ({
                              ...formData,
                              area: floatValue
                            }));
                          }}
                          disabled={isStatusPaid || (type === "EDIT" && !isACLAssessor)}
                          isAllowed={withValueCap}
                          isNumericString
                          thousandSeparator
                          allowNegative
                          allowLeadingZeros
                          displayType="input"
                          prefix=""
                          value={_.get(formData, 'area', '') || ''}
                        />
                      )} 
                    />
                    <InputTemplate
                      // isInputMask
                      title="OCT / TCT / CLOA NO."
                      htmlFor="oct_tct_cloa_no"
                      containerClassName="col-sm-12 col-md-6"
                      // formValidatorMsg={validateForm.renderMessage("oct_tct_cloa_no")}
                      // Input component props
                      placeholder=""
                      // className="full-input-v2 text-uppercase"
                      className="full-input-v2"
                      disabled={isStatusPaid || (type === "EDIT" && !isACLAssessor)}
                      // mask="999-999-999"
                      id="oct_tct_cloa_no"
                      name="oct_tct_cloa_no"
                      type="text"
                      autoComplete="none"
                      onChange={onChange}
                      value={_.get(formData, 'oct_tct_cloa_no')?.toUpperCase() || ''}
                    />
                    <InputTemplate
                      // isInputMask
                      title="Survey No."
                      htmlFor="survey_no"
                      containerClassName="col-sm-12 col-md-6"
                      // formValidatorMsg={validateForm.renderMessage("survey_no")}
                      // Input component props
                      placeholder=""
                      // className="full-input-v2 text-uppercase"
                      className="full-input-v2"
                      disabled={isStatusPaid || (type === "EDIT" && !isACLAssessor)}
                      // mask="999-999-999"
                      id="survey_no"
                      name="survey_no"
                      type="text"
                      autoComplete="none"
                      onChange={onChange}
                      value={_.get(formData, 'survey_no')?.toUpperCase() || ''}
                    />
                    <InputTemplate
                      title="Lot No."
                      htmlFor="lot_no"
                      containerClassName="col-sm-12 col-md-6"
                      // formValidatorMsg={validateForm.renderMessage("lot_no")}
                      // Input component props
                      placeholder="Lot No."
                      // className="full-input-v2 text-uppercase"
                      className="full-input-v2"
                      disabled={isStatusPaid || (type === "EDIT" && !isACLAssessor)}
                      mask="000-000-000"
                      id="lot_no"
                      name="lot_no"
                      type="text"
                      autoComplete="none"
                      onChange={onChange}
                      value={_.get(formData, 'lot_no')?.toUpperCase() || ''}
                    />
                    <InputTemplate
                      title="Block No."
                      htmlFor="block_no"
                      containerClassName="col-sm-12 col-md-6"
                      // formValidatorMsg={validateForm.renderMessage("block_no")}
                      // Input component props
                      placeholder="Block No."
                      // className="full-input-v2 text-uppercase"
                      className="full-input-v2"
                      disabled={isStatusPaid || (type === "EDIT" && !isACLAssessor)}
                      id="block_no"
                      name="block_no"
                      type="text"
                      onChange={onChange}
                      value={_.get(formData, 'block_no')?.toUpperCase() || ''}
                    />
                    <InputTemplate
                      isSelect
                      title="Kind of Property"
                      htmlFor="kind_of_property"
                      containerClassName="col-sm-12 col-md-6"
                      formValidatorMsg={validateForm.renderMessage("kind_of_property")}
                      // Input component props
                      placeholder=""
                      styles={reactSelectCustomStyleCms()}
                      // className="full-input text-uppercase"
                      className="full-input"
                      isDisabled={isStatusPaid || (type === "EDIT" && !isACLAssessor)}
                      id="kind_of_property"
                      name="kind_of_property"
                      type="text"
                      onChange={handleOnChangeSelect('kind_of_property')}
                      options={c.PROPERTY_KINDS}
                      value={c.PROPERTY_KINDS.find((item) => _.get(formData, "kind_of_property") === _.get(item, "value")) || ""} // placeholdef value only
                      components={{ IndicatorSeparator: () => null }}
                    />
                    <InputTemplate
                      isSelect
                      title="Classification"
                      htmlFor="classification"
                      containerClassName="col-sm-12 col-md-6"
                      formValidatorMsg={validateForm.renderMessage("classification")}
                      // Input component props
                      placeholder=""
                      styles={reactSelectCustomStyleCms()}
                      // className="full-input text-uppercase"
                      className="full-input"
                      isDisabled={isStatusPaid || (type === "EDIT" && !isACLAssessor)}
                      id="classification"
                      name="classification"
                      type="text"
                      onChange={handleOnChangeSelect('classification')}
                      options={c.CLASSIFICATIONS}
                      value={c.CLASSIFICATIONS.find((item) => _.get(formData, "classification") === _.get(item, "value")) || ""} // placeholdef value only
                      components={{ IndicatorSeparator: () => null }}
                    />
                    <InputTemplate
                      title="Special Classes"
                      htmlFor="special_class"
                      containerClassName="col-sm-12 col-md-6"
                      // formValidatorMsg={validateForm.renderMessage("special_class")}
                      // Input component props
                      placeholder=""
                      // className="full-input-v2 text-uppercase"
                      className="full-input-v2"
                      disabled={isStatusPaid || (type === "EDIT" && !isACLAssessor)}
                      id="special_class"
                      name="special_class"
                      type="text"
                      onChange={onChange}
                      value={_.get(formData, 'special_class')?.toUpperCase() || ''}
                    />
                  </div>
                </div>
                <div className="full-group-v2">
                  <h3 className="font-weight-bolder mb-2 mt-4 cms-text-primary">Boundaries</h3>
                  <div className="form-row">
                    <InputTemplate
                      title="North"
                      htmlFor="boundaries_north"
                      containerClassName="col-sm-12 col-md-6"
                      // formValidatorMsg={validateForm.renderMessage("boundaries_north")}
                      // Input component props
                      placeholder="0"
                      // className="full-input-v2 text-uppercase"
                      className="full-input-v2"
                      disabled={isStatusPaid || (type === "EDIT" && !isACLAssessor)}
                      id="boundaries_north"
                      name="boundaries_north"
                      type="text"
                      onChange={onChange}
                      value={_.get(formData, 'boundaries_north')?.toUpperCase() || ''}
                    />
                    <InputTemplate
                      title="South"
                      htmlFor="boundaries_south"
                      containerClassName="col-sm-12 col-md-6"
                      // formValidatorMsg={validateForm.renderMessage("boundaries_south")}
                      // Input component props
                      placeholder="0"
                      // className="full-input-v2 text-uppercase"
                      className="full-input-v2"
                      disabled={isStatusPaid || (type === "EDIT" && !isACLAssessor)}
                      id="boundaries_south"
                      name="boundaries_south"
                      type="text"
                      onChange={onChange}
                      value={_.get(formData, 'boundaries_south')?.toUpperCase() || ''}
                    />
                    <InputTemplate
                      title="East"
                      htmlFor="boundaries_east"
                      containerClassName="col-sm-12 col-md-6"
                      // formValidatorMsg={validateForm.renderMessage("boundaries_east")}
                      // Input component props
                      placeholder="0"
                      // className="full-input-v2 text-uppercase"
                      className="full-input-v2"
                      disabled={isStatusPaid || (type === "EDIT" && !isACLAssessor)}
                      id="boundaries_east"
                      name="boundaries_east"
                      type="text"
                      onChange={onChange}
                      value={_.get(formData, 'boundaries_east')?.toUpperCase() || ''}
                    />
                    <InputTemplate
                      title="West"
                      htmlFor="boundaries_west"
                      containerClassName="col-sm-12 col-md-6"
                      // formValidatorMsg={validateForm.renderMessage("boundaries_west")}
                      // Input component props
                      placeholder="0"
                      // className="full-input-v2 text-uppercase"
                      className="full-input-v2"
                      disabled={isStatusPaid || (type === "EDIT" && !isACLAssessor)}
                      id="boundaries_west"
                      name="boundaries_west"
                      type="text"
                      onChange={onChange}
                      value={_.get(formData, 'boundaries_west')?.toUpperCase() || ''}
                    />
                  </div>
                </div>
              </>
            )
          }
          {/* 3rd Page */}
          {
             tab === 2 && (
              <>
                <div className="full-group-v2">
                  <h3 className="font-weight-bolder mb-2 mt-4 cms-text-primary">Amount</h3>
                    <div style={{ overflowX: 'scroll' }}>
                      {/* grand total */}
                      <div className="mt-2 mb-4">
                        <div className="my-1 d-flex align-items-center justify-content-between rounded" style={{ minWidth: '720px'}}>
                          <h4 className="pl-2 h4 font-weight-bolder span-title2 my-0">Assessed Value</h4>
                          <div className="font-weight-bolder text-dark my-0">
                            <InputTemplate
                              containerClassName="mx-2"
                              // formValidatorMsg={validateForm.renderMessage("first_quarter")}
                              withCustomInputComponent={() => (
                                <NumberFormat
                                  name="assessed_value"
                                  id="assessed_value"
                                  placeholder="PHP 0.00"
                                  // className="full-input-v2 text-uppercase my-2"
                                  className="full-input-v2"
                                  style={{ minWidth: '450px'}}
                                  onValueChange={values => {
                                    const { floatValue } = values
                                    setFormData(() => ({
                                      ...formData,
                                      assessed_value: floatValue,
                                    }));
                                  }}
                                  disabled={isStatusPaid || (type === "EDIT" && isACLAssessor)}
                                  isAllowed={withValueCap}
                                  isNumericString
                                  thousandSeparator
                                  allowNegative
                                  allowLeadingZeros
                                  displayType="input"
                                  prefix="PHP "
                                  value={_.get(formData, 'assessed_value', '')?.toString() || ''}
                                />
                              )} 
                            />
                          </div>
                        </div>
                        <div className="mt-2 mb-3 d-flex align-items-center justify-content-between rounded" style={{ minWidth: '720px'}}>
                          <h4 className="pl-2 h4 font-weight-bolder span-title2 my-0">Tax Due</h4>
                          <div className="font-weight-bolder text-dark my-0">
                            <InputTemplate
                              containerClassName="mx-2"
                              // formValidatorMsg={validateForm.renderMessage("first_quarter")}
                              withCustomInputComponent={() => (
                                <NumberFormat
                                  name="tax_due"
                                  id="tax_due"
                                  placeholder="PHP 0.00"
                                  // className="full-input-v2 text-uppercase my-2"
                                  className="full-input-v2"
                                  style={{ minWidth: '450px'}}
                                  onValueChange={values => {
                                    const { floatValue } = values
                                    setFormData(() => ({
                                      ...formData,
                                      tax_due: floatValue,
                                    }));
                                  }}
                                  disabled={isStatusPaid || (type === "EDIT" && isACLAssessor)}
                                  isAllowed={withValueCap}
                                  isNumericString
                                  thousandSeparator
                                  allowNegative
                                  allowLeadingZeros
                                  displayType="input"
                                  prefix="PHP "
                                  value={_.get(formData, 'tax_due', '')?.toString() || ''}
                                />
                              )} 
                            />
                          </div>
                        </div>
                        <div className="my-2 py-2 d-flex align-items-center justify-content-center rounded cms-bg-color-light">
                          <button
                            type="button"
                            disabled={
                              !_.get(formData, "tdn") ||
                              !_.get(formData, "pin") ||
                              !_.get(formData, "year") ||
                              !_.get(formData, "tax_due") || 
                              isStatusPaid
                            }
                            className="btn btn-light button-proceed ml-1 px-4 cms-bg-color-primary"
                            style={{ color: '#fff' }}
                            onClick={handleCalculatePenaltyAndDiscount}
                          >
                            {calculating ? <i className="fas fa-spinner fa-spin fa-lg" /> : 'Calculate'}
                          </button>
                        </div>
                        <div className="my-1 d-flex align-items-center justify-content-between rounded" style={{ minWidth: '720px'}}>
                          <h4 className="pl-2 h4 font-weight-bolder span-title2 my-0">Discount</h4>
                          <div className="font-weight-bolder text-dark my-0">
                            <InputTemplate
                              containerClassName="mx-2"
                              withCustomInputComponent={() => (
                                <NumberFormat
                                  name="discount"
                                  id="discount"
                                  placeholder="PHP 0.00"
                                  className="full-input-v2"
                                  style={{ minWidth: '450px'}}
                                  onValueChange={values => {
                                    const { floatValue } = values
                                    setFormData(() => ({
                                      ...formData,
                                      discount: floatValue,
                                    }));
                                  }}
                                  disabled={isStatusPaid || (type === "EDIT" && isACLAssessor)}
                                  isAllowed={withValueCap}
                                  isNumericString
                                  thousandSeparator
                                  allowNegative
                                  allowLeadingZeros
                                  displayType="input"
                                  prefix="PHP "
                                  value={_.get(formData, 'discount', '')?.toString() || ''}
                                />
                              )} 
                            />
                          </div>
                        </div>
                        <div className="my-1 d-flex align-items-center justify-content-between rounded" style={{ minWidth: '720px'}}>
                          <h4 className="pl-2 h4 font-weight-bolder span-title2 my-0">Penalty</h4>
                          <div className="font-weight-bolder text-dark my-0">
                            <InputTemplate
                              containerClassName="mx-2"
                              withCustomInputComponent={() => (
                                <NumberFormat
                                  name="penalty"
                                  id="penalty"
                                  placeholder="PHP 0.00"
                                  className="full-input-v2"
                                  style={{ minWidth: '450px'}}
                                  onValueChange={values => {
                                    const { floatValue } = values
                                    setFormData(() => ({
                                      ...formData,
                                      penalty: floatValue,
                                    }));
                                  }}
                                  disabled={isStatusPaid || (type === "EDIT" && isACLAssessor)}
                                  isAllowed={withValueCap}
                                  isNumericString
                                  thousandSeparator
                                  allowNegative
                                  allowLeadingZeros
                                  displayType="input"
                                  prefix="PHP "
                                  value={_.get(formData, 'penalty', '')?.toString() || ''}
                                />
                              )} 
                            />
                          </div>
                        </div>
                      </div>
                      <div className="container-fluid mx-auto px-0" style={{ minWidth: '720px' }}>
                        <div className="mb-2 justify-content-center quarter-container">
                          <div className="d-flex align-items-center cms-bg-color-primary-light border-bottom p-2">
                            <b className=" m-0 cms-text-primary ">1st Quarter</b>
                          </div>
                          <div className="d-flex align-items-center cms-bg-color-primary-light border-bottom p-2">
                            <b className=" m-0 cms-text-primary">
                              2nd Quarter
                            </b>
                          </div>
                          <div className="d-flex align-items-center cms-bg-color-primary-light border-bottom p-2">
                            <b className=" m-0 cms-text-primary">
                              3rd Quarter
                            </b>
                          </div>
                          <div className="d-flex align-items-center cms-bg-color-primary-light border-bottom p-2">
                            <b className=" m-0 cms-text-primary">4th Quarter</b>
                          </div>
                          {/* <div className="d-none col-1 d-flex align-items-center justify-content-center p-2" /> */}
                        </div>
                      </div>

                      <div className="quarter-container pt-2 pb-3 mt-1 justify-content-center border-bottom" style={{ maxHeight: "400px", minWidth: '720px' }}>
                        <div className="">
                          <InputTemplate
                            containerClassName="mx-1"
                            // formValidatorMsg={validateForm.renderMessage("first_quarter")}
                            withCustomInputComponent={() => (
                              <NumberFormat
                                name="first_quarter"
                                id="first_quarter"
                                placeholder="PHP 0.00"
                                // className="full-input-v2 text-uppercase my-2"
                                className="full-input-2"
                                onValueChange={values => {
                                  const { floatValue } = values
                                  setFormData(() => ({
                                    ...formData,
                                    first_quarter: floatValue
                                  }));
                                }}
                                isAllowed={withValueCap}
                                isNumericString
                                thousandSeparator
                                allowNegative
                                allowLeadingZeros
                                decimalScale={2}
                                displayType="text"
                                prefix="PHP "
                                value={_.get(formData, 'first_quarter', '') || '0'}
                              />
                            )} 
                          />
                        </div>
                        <div className="">
                          <InputTemplate
                            containerClassName="mx-1"
                            // formValidatorMsg={validateForm.renderMessage("second_quarter")}
                            withCustomInputComponent={() => (
                              <NumberFormat
                                name="second_quarter"
                                id="second_quarter"
                                placeholder="PHP 0.00"
                                // className="full-input-v2 text-uppercase my-2"
                                className="full-input-2"
                                onValueChange={values => {
                                  const { floatValue } = values
                                  setFormData(() => ({
                                    ...formData,
                                    second_quarter: floatValue
                                  }));
                                }}
                                isAllowed={withValueCap}
                                isNumericString
                                thousandSeparator
                                allowNegative
                                allowLeadingZeros
                                decimalScale={2}
                                displayType="text"
                                prefix="PHP "
                                value={_.get(formData, 'second_quarter', '') || '0'}
                              />
                            )} 
                          />
                        </div>
                        <div className="">
                          <InputTemplate
                            containerClassName="mx-1"
                            // formValidatorMsg={validateForm.renderMessage("third_quarter")}
                            withCustomInputComponent={() => (
                              <NumberFormat
                                name="third_quarter"
                                id="third_quarter"
                                placeholder="PHP 0.00"
                                // className="full-input-v2 text-uppercase my-2"
                                className="full-input-2"
                                onValueChange={values => {
                                  const { floatValue } = values
                                  setFormData(() => ({
                                    ...formData,
                                    third_quarter: floatValue
                                  }));
                                }}
                                isAllowed={withValueCap}
                                isNumericString
                                thousandSeparator
                                allowNegative
                                allowLeadingZeros
                                decimalScale={2}
                                displayType="text"
                                prefix="PHP "
                                value={_.get(formData, 'third_quarter', '') || '0'}
                              />
                            )}
                          />
                        </div>
                        <div className="">
                        <InputTemplate
                            containerClassName="mx-1"
                            // formValidatorMsg={validateForm.renderMessage("fourth_quarter")}
                            withCustomInputComponent={() => (
                              <NumberFormat
                                name="fourth_quarter"
                                id="fourth_quarter"
                                placeholder="PHP 0.00"
                                // className="full-input-v2 text-uppercase my-2"
                                className="full-input-2"
                                onValueChange={values => {
                                  const { floatValue } = values
                                  setFormData(() => ({
                                    ...formData,
                                    fourth_quarter: floatValue
                                  }));
                                }}
                                isAllowed={withValueCap}
                                isNumericString
                                thousandSeparator
                                allowNegative
                                allowLeadingZeros
                                decimalScale={2}
                                displayType="text"
                                prefix="PHP "
                                value={_.get(formData, 'fourth_quarter', '') || '0'}
                              />
                            )} 
                          />
                        </div>
                      </div>

                      {/* scroll */}
                    </div>

                </div>
              </>
             )
          }
        </div>

        {paginateButton()}
      </form>
    </Modal.Body>
  );
}

AddRecordModalBoronganV2.defaultProps = {
  type: '',
  dataInfo: {},
  dataInclude: {},
  id: '',
};

AddRecordModalBoronganV2.propTypes = {
  permissions: PropTypes.instanceOf(Object).isRequired,
  getListManualImportBorongan: PropTypes.instanceOf(Function).isRequired,
  createRecordManualImportBorongan: PropTypes.instanceOf(Function).isRequired,
  updateRecordManualImportBorongan: PropTypes.instanceOf(Function).isRequired,
  updateAmountFeesBorongan: PropTypes.instanceOf(Function).isRequired,
  calculatePenaltyDiscount: PropTypes.instanceOf(Function).isRequired,
  history: PropTypes.instanceOf(Object).isRequired,
  creating: PropTypes.bool.isRequired,
  calculating: PropTypes.bool.isRequired,
  type: PropTypes.string,
  id: PropTypes.string,
  dataInfo: PropTypes.instanceOf(Object),
  dataInclude: PropTypes.instanceOf(Object),
};

const mapStateToProps = ({ api }) => ({
  permissions: getJson('permissions'),
  creating: api.loading.indexOf(c.CREATE_RECORD_MANUAL_IMPORT) > -1,
  calculating: api.loading.indexOf(c.CALCULATE_PENALTY_DISCOUNT) > -1,
});

const enhance = _.flowRight([
  withForm,
  withRouter,
  connect(mapStateToProps, {
    ...actions,
  }),
]);

export default enhance(AddRecordModalBoronganV2);
